import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SuajeService, Pegue } from '../../services/suaje.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { MaterializeAction } from 'angular2-materialize';
import { Utils } from '../../util';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-create-suaje',
  templateUrl: './create-suaje.component.html',
  styleUrls: ['./create-suaje.component.css']
})
export class CreateSuajeComponent implements OnInit,OnDestroy {
  loading: boolean[] = [false];
  get loaded(): boolean { return !this.loading.includes(false); }

  clabeError: boolean;

  suajeForm: FormGroup;
  pegue: Pegue = {
    FA: false,
    lineal: false,
    esquinas4: false,
    NA : false,
  };

  initials: string = '  ';

  customerSub: Subscription;

  constructor(
    private suajeService: SuajeService,
    private customerService: CustomerSupplierService,
    private fb: FormBuilder,
  ) {

    this.customerSub = this.customerService.getCustomers().subscribe(customers => {
      this.rowsRead[0] = customers.map(customer => {
        customer.id = customer.id$;
        this.customers[customer.id] = customer;
        return customer;
      })
      this.loading[0] = true;
    });
  }

  ngOnInit() {
    this.createForm();
  }
  ngOnDestroy(){
    if(this.customerSub) this.customerSub.unsubscribe();
  }

  createForm() {
    this.suajeForm = this.fb.group({
      code: ['SJ-  -0000', Validators.required],
      long: ['', Validators.required],
      wide: ['', Validators.required],
      height: ['', Validators.required],
      horizontal: ['', Validators.required],
      vertical: ['', Validators.required],
      rows: ['', Validators.required],
      columns: ['', Validators.required],
      other: '',
      notes: '',
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    let suaje = {
      pegue: this.pegue,
      customerRef: this.selectedCustomerId,
      ...value
    }
    this.suajeService.addSuaje(suaje);
    this.customerService.incrementNextSuaje(this.selectedCustomerId);
    this.suajeService.windowReplace('read');
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  selectedIds: string[] = [];
  currentReadIndex: number;

  customers = {};
  get selectedCustomerId(): string { return this.selectedIds[0]; }

  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  openModalRead(index: number) {
    this.currentReadIndex = index;
    this.data = this.rowsRead[index];
    
    this.config = this.configs[index];
  
    this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead(data: any): any{
    this.selectedIds[this.currentReadIndex] = data.row.id;
    if(!this.currentReadIndex){
      let nextSuaje = data.row.nextSuaje || 0;
      this.initials = data.row.initials;
      this.suajeForm.get('code').patchValue(`SJ-${this.initials}-${Utils.String.fillLeft(`${nextSuaje}`, '0', 4)}`);
    }
    this.closeModalRead();
  }

  get readValid(){ return this.selectedIds[0] };
  rowsRead = [[]];
  columnsRead = [
    [//customer
      { title: 'Nombre', name: 'name', sort: 'asc' },
      { title: 'Descripción', name: 'description' },
      { title: 'Correo electrónico', name: 'email' }
    ]
  ]

  data:Array<any>;
  rows:Array<any> = [];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config;
  configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));

  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA


}
